module.exports = __webpack_public_path__ + "img/philippines.33564a5b.png";